/**
 * Éditeur de disponibilité hebdomadaire (heures/jour) — présentation lisible
 * partagée par `PersonFormModal` (dispo courante en création) et
 * `WorkScheduleSection` (versions datées).
 *
 * Grille 7 jours aérée : week-end visuellement atténué, total h/semaine affiché,
 * steppers natifs. En lecture seule (`readOnly`), affiche les valeurs sans input.
 */

export const WORK_DAYS = [
  { key: 'monday', label: 'Lun', weekend: false },
  { key: 'tuesday', label: 'Mar', weekend: false },
  { key: 'wednesday', label: 'Mer', weekend: false },
  { key: 'thursday', label: 'Jeu', weekend: false },
  { key: 'friday', label: 'Ven', weekend: false },
  { key: 'saturday', label: 'Sam', weekend: true },
  { key: 'sunday', label: 'Dim', weekend: true },
];

export const DEFAULT_WORK_DAYS = {
  monday: 8,
  tuesday: 8,
  wednesday: 8,
  thursday: 8,
  friday: 8,
  saturday: 0,
  sunday: 0,
};

/** Total d'heures hebdomadaires (somme des 7 jours). */
export function weeklyTotal(value) {
  return WORK_DAYS.reduce((acc, d) => acc + (Number(value?.[d.key]) || 0), 0);
}

export default function WorkDaysEditor({ value, onChange, readOnly = false }) {
  const total = weeklyTotal(value);

  return (
    <div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 1fr)',
          gap: 8,
        }}
      >
        {WORK_DAYS.map((d) => {
          const v = value?.[d.key] ?? 0;
          const isEmpty = !Number(v);
          return (
            <div
              key={d.key}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 6,
                padding: '8px 4px',
                background: d.weekend ? 'transparent' : 'var(--glass)',
                border: `1px solid ${d.weekend ? 'var(--glass-border)' : 'var(--glass-border)'}`,
                borderRadius: 'var(--radius-sm)',
                opacity: d.weekend && isEmpty ? 0.55 : 1,
              }}
            >
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  letterSpacing: '0.02em',
                  color: 'var(--text-muted)',
                  textTransform: 'uppercase',
                }}
              >
                {d.label}
              </span>
              {readOnly ? (
                <span style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)' }}>{v}</span>
              ) : (
                <input
                  type="number"
                  step="0.5"
                  min="0"
                  max="24"
                  value={v}
                  onChange={(e) => onChange?.(d.key, e.target.value)}
                  aria-label={`Heures ${d.label}`}
                  style={{
                    width: '100%',
                    padding: '6px 4px',
                    textAlign: 'center',
                    fontSize: 15,
                    fontWeight: 600,
                    background: 'var(--bg)',
                    color: 'var(--text)',
                    border: '1px solid var(--glass-border)',
                    borderRadius: 'var(--radius-sm)',
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
      <div
        style={{
          marginTop: 8,
          display: 'flex',
          justifyContent: 'flex-end',
          fontSize: 12,
          color: 'var(--text-muted)',
        }}
      >
        Total&nbsp;<strong style={{ color: 'var(--text)' }}>{total} h</strong>&nbsp;/ semaine
      </div>
    </div>
  );
}
